import React from "react";

const ProductCard = ({ product }) => {
  const discount =
    product.oldPrice && product.price
      ? Math.round(
          ((parseFloat(product.oldPrice.slice(1)) -
            parseFloat(product.price.slice(1))) /
            parseFloat(product.oldPrice.slice(1))) *
            100
        )
      : null;

  return (
    <div className="border  overflow-hidden shadow-sm p-2 hover:shadow-md transition-all duration-300 w-full">
      <div className="relative">
        {discount && (
          <span className="absolute top-2 left-2 bg-green-500 text-white text-xs px-2 py-1 rounded">
            {discount}% OFF
          </span>
        )}
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-60 sm:h-64 md:h-72 object-cover rounded"
        />
      </div>
      <div className="mt-3 px-1">
        <p className="text-xs sm:text-sm text-yellow-600 font-medium flex items-center gap-1">
          ⭐ {product.reviewCount || 1} review
        </p>
        <h3 className="text-sm sm:text-[15px] mt-1 font-semibold line-clamp-2">
          {product.name}
        </h3>
        <div className="mt-1 flex flex-wrap items-center gap-2 text-sm">
          {product.oldPrice && (
            <span className="text-gray-400 line-through">
              {product.oldPrice}
            </span>
          )}
          <span className="font-bold text-base text-black">{product.price}</span>
        </div>
        <div className="flex gap-1 mt-2">
          {product.colors.map((color, i) => (
            <span
              key={i}
              className="w-4 h-4 rounded-full border"
              style={{ backgroundColor: color }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;